import React, { useState } from 'react'
import { CardMedia, Box } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const images = [
    '../picture_placeholder_001.jpg',
    '../picture_placeholder_002.jpg',
    '../picture_placeholder_003.jpg',
]

// DECISION: height is now a prop (defaulting to the original 220px) instead
// of a hard-coded value, so the same component can be shown larger on the
// "Bien" tab — where it finally has room — without a second copy of this
// file.
const PhotoCarousel = ({ height = '220px' }) => {
    const [activeIndex, setActiveIndex] = useState(0)

    const handlePrev = () => {
        setActiveIndex(prev => (prev === 0 ? images.length - 1 : prev - 1))
    }
    const handleNext = () => {
        setActiveIndex(prev => (prev === images.length - 1 ? 0 : prev + 1))
    }

    return (
        <Box sx={{ position: 'relative', height }}>

            {/* ── Image ── */}
            <CardMedia
                component="img"
                image={images[activeIndex]}
                alt={`Photo ${activeIndex + 1}`}
                sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 1 }}
            />

            {/* ── Prev button ── */}
            <Box
                onClick={handlePrev}
                sx={{
                    position:        'absolute',
                    top:             0,
                    left:            0,
                    width:           '15%',
                    height:          '100%',
                    display:         'flex',
                    alignItems:      'center',
                    justifyContent:  'flex-start',
                    cursor:          'pointer',
                    transition:      'background 0.2s',
                    '&:hover': {
                        background: 'linear-gradient(to right, rgba(0,0,0,0.25) 0%, transparent 100%)',
                    },
                }}
            >
                <ChevronLeft sx={{ fontSize: 32, color: 'white', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.6))' }} />
            </Box>

            {/* ── Next button ── */}
            <Box
                onClick={handleNext}
                sx={{
                    position:        'absolute',
                    top:             0,
                    right:           0,
                    width:           '15%',
                    height:          '100%',
                    display:         'flex',
                    alignItems:      'center',
                    justifyContent:  'flex-end',
                    cursor:          'pointer',
                    transition:      'background 0.2s',
                    '&:hover': {
                        background: 'linear-gradient(to left, rgba(0,0,0,0.25) 0%, transparent 100%)',
                    },
                }}
            >
                <ChevronRight sx={{ fontSize: 32, color: 'white', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.6))' }} />
            </Box>

            {/* ── Dot indicators ── */}
            <Box
                sx={{
                    position:       'absolute',
                    bottom:         8,
                    left:           0,
                    right:          0,
                    display:        'flex',
                    justifyContent: 'center',
                    gap:            0.75,
                    pointerEvents:  'none',
                }}
            >
                {images.map((_, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            width:        idx === activeIndex ? 18 : 6,
                            height:       6,
                            borderRadius: 3,
                            bgcolor:      idx === activeIndex ? 'white' : 'rgba(255,255,255,0.5)',
                            transition:   'width 0.25s ease, background-color 0.25s ease',
                            boxShadow:    '0 1px 3px rgba(0,0,0,0.4)',
                        }}
                    />
                ))}
            </Box>

        </Box>
    )
}

export default PhotoCarousel
